// extracted by mini-css-extract-plugin
export default {"disabled":"styles_disabled__-q8ke","active":"styles_active__b4UbX"};